import TopFiltersGroupRegister from './TopFiltersGroupRegister';
export default TopFiltersGroupRegister;
